import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "Pensavo di avere un problema di business. In realtà avevo smesso di ascoltarmi. Francesco mi ha ridato la lucidità che avevo perso da anni.",
    name: "M. R.",
    role: "CEO, azienda manifatturiera",
  },
  {
    quote:
      "Non cerca di piacerti. Ti dice la verità. È esattamente ciò di cui, al mio posto, avevo un disperato bisogno.",
    name: "A. V.",
    role: "Founder, scale-up tech",
  },
  {
    quote:
      "Ho investito in tanti percorsi. Questo è l'unico che ha toccato la persona, non solo il manager. Un lavoro raro.",
    name: "L. B.",
    role: "Imprenditore",
  },
];

export default function Testimonials() {
  return (
    <section
      id="voci"
      className="relative bg-background py-28 md:py-40 border-t border-white/10"
      data-testid="testimonials-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-24 flex items-end justify-between flex-wrap gap-6">
          <div className="max-w-2xl">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-primary" />
              <span className="text-[11px] tracking-[0.35em] text-primary">
                VOCI
              </span>
            </div>
            <h2 className="font-serif font-light text-4xl md:text-5xl text-foreground leading-tight">
              Riservatezza assoluta. Risultati concreti.
            </h2>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs">
            I nomi dei miei clienti restano privati. La loro voce, con il loro
            consenso, no.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-2xl border border-white/10 bg-card p-8 md:p-10 flex flex-col justify-between min-h-[360px]"
              data-testid={`testimonial-${i}`}
            >
              <span className="font-serif text-6xl text-primary/40 leading-none">
                “
              </span>
              <blockquote className="font-serif text-xl md:text-2xl text-foreground leading-snug -mt-4">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10">
                <div className="text-sm text-foreground tracking-wide">
                  {t.name}
                </div>
                <div className="text-xs text-muted-foreground mt-1">
                  {t.role}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
